// extracted by mini-css-extract-plugin
export default {"container":"PromotionModal_container__dJnuO","error":"PromotionModal_error__q+Vu1"};